import type {CSSProperties} from 'react';
import {wedgeExactRole, wedgeRole} from './wedgeRoles.js';

export type WedgeProvenanceLook = 'provenance-row' | 'provenance-more';

const PROVENANCE_LOOKS = new Set<string>(['provenance-row', 'provenance-more']);
export const isWedgeProvenanceLook = (look: string | undefined): look is WedgeProvenanceLook => look !== undefined && PROVENANCE_LOOKS.has(look);

/* Released brief provenance tags (ProvenanceTags). A row is a full width block button with a half pixel separator on top, 7px of vertical
   padding, left aligned 12.5px text at 1.4 line height in the label ink, a bare fill and no other border. The "show all" button under the
   rows is a bare 9.5px bold uppercase mono line with 6px of vertical padding and the tertiary ink. Both keep the tap highlight off and
   manipulation touch action. The caller owns the labels, the expanded state and the detail line. Neither look draws a transparent target
   or an anchor (wedgeSettingsDrawsHit): a 44px region on the 12.5px row would reach into the neighbor rows, which sit edge to edge, and the
   9.5px line sits in a column of rows under the same rule. */
export function wedgeProvenanceStyle(look: WedgeProvenanceLook): CSSProperties {
  const r = wedgeExactRole;
  const mono = wedgeRole('mono', "ui-monospace, 'Share Tech Mono', monospace");
  if (look === 'provenance-row') return {
    display: 'block', width: '100%', textAlign: 'left',
    background: 'transparent', border: 0, padding: '7px 0',
    borderTop: `0.5px solid ${r('separator')}`, cursor: 'pointer',
    color: r('label'), fontSize: 12.5, lineHeight: 1.4,
    WebkitTapHighlightColor: 'transparent', touchAction: 'manipulation',
  };
  return {
    background: 'transparent', border: 0, padding: '6px 0', cursor: 'pointer',
    fontFamily: mono, fontSize: 9.5, fontWeight: 700, letterSpacing: 0.08,
    textTransform: 'uppercase', color: r('labelTer'),
    WebkitTapHighlightColor: 'transparent', touchAction: 'manipulation',
  };
}
